import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';
import { ContactOptionsInterface } from '@interfaces/contact/contact-options-interface';
import { ContactInterface } from '@interfaces/contact/contact-interface';
import { LanguageService } from '@core/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private http = inject(HttpClient);
  private contactEndpoint = environment.endpoints.contact;
  private contactOptionsEndpoint = environment.endpoints.contactOptions;
  private api = environment.API_URL;
  private locale = inject(LanguageService);
  public sendContact(contact: ContactInterface, captchaToken = ''): Observable<ApiResponse<void>> {
    let httpParams = new HttpParams();
    console.log(`ContactService captchaToken = '${captchaToken}'`);
    const headers = new HttpHeaders({ 'x-captcha-token': captchaToken });
    httpParams = httpParams.set('locale', this.locale.getCurrentLanguage().toUpperCase());
    return this.http.post<ApiResponse<void>>(`${this.api}/${this.contactEndpoint}`, contact, {
      headers: headers,
      params: httpParams,
    });
  }

  public getContactOptions(): Observable<ApiResponse<ContactOptionsInterface[]>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('locale', this.locale.getCurrentLanguage().toUpperCase());
    return this.http.get<ApiResponse<ContactOptionsInterface[]>>(`${this.api}/${this.contactOptionsEndpoint}`, {
      params: httpParams,
    });
  }
}
